<div class="status-container">
    <div class="protocolos-header">
        <span class="protocolos-header-icon">
            <i class="pi pi-inbox"></i>
        </span>
        <div class="protocolos-header-copy">
            <!--            <span class="eyebrow">Protocolos</span>-->
            <h5 class="title">{{ titulo }}</h5>
            <p>Selecione um protocolo para visualizar as informações do serviço.</p>
        </div>
        <div class="lista-toolbar">
            <label class="toolbar-search">
                <i class="pi pi-search" aria-hidden="true"></i>
                <input type="text" inputmode="numeric" placeholder="Protocolo" [ngModel]="numeroProtocoloBusca()" (ngModelChange)="numeroProtocoloBusca.set($event)" aria-label="Filtrar por número do protocolo" />
                @if (localizacaoAtiva) {
                    <button type="button" class="toolbar-search-clear" (click)="limparLocalizacao()" aria-label="Limpar protocolo">
                        <i class="pi pi-times" aria-hidden="true"></i>
                    </button>
                }
            </label>
            @if (!noArquivo()) {
                <button type="button" class="toolbar-btn" [class.ativo]="filtroPagamentoAplicado !== 'todos'" (click)="exibirDialogFiltros.set(true)">
                    <i class="pi pi-filter"></i>
                    <span>Filtros</span>
                </button>
                @if (possuiFiltroAtivo) {
                    <button type="button" class="toolbar-btn toolbar-btn-clear" (click)="limparFiltros()">
                        <i class="pi pi-times"></i>
                        <span>Limpar</span>
                    </button>
                }
            }
        </div>
    </div>

    <app-tab-container role="group" aria-label="Alternar entre o quadro de protocolos e o arquivo" [options]="opcoesAba" [(selected)]="abaSelecionada" (onChanged)="aoTrocarAba($event)" [useHeader]="false"></app-tab-container>

    <div class="stats-grid">
        @if (noArquivo()) {
            <div class="stat-card">
                <div class="stat-info">
                    <span class="stat-rotulo">Total arquivados</span>
                    <strong class="stat-valor">{{ resumoArquivo()?.total ?? '—' }}</strong>
                </div>
            </div>
            <div class="stat-card stat-card--success">
                <div class="stat-info">
                    <span class="stat-rotulo">Concluídos no ano</span>
                    <strong class="stat-valor">{{ resumoArquivo()?.concluidosNoAno ?? '—' }}</strong>
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-info">
                    <span class="stat-rotulo">Tempo médio</span>
                    <strong class="stat-valor">{{ tempoMedioArquivoTexto() }}</strong>
                </div>
            </div>
        } @else {
            <div class="stat-card">
                <div class="stat-info">
                    <span class="stat-rotulo">Total</span>
                    <strong class="stat-valor">{{ totalProtocolos }}</strong>
                </div>
            </div>
            <div class="stat-card stat-card--success">
                <div class="stat-info">
                    <span class="stat-rotulo">Pagos</span>
                    <strong class="stat-valor">{{ totalPagos }}</strong>
                </div>
            </div>
            <div class="stat-card stat-card--danger">
                <div class="stat-info">
                    <span class="stat-rotulo">Pendências</span>
                    <strong class="stat-valor">{{ totalPendencias }}</strong>
                </div>
            </div>
        }
    </div>

    <div class="lista-scroll">
        @if (noArquivo()) {
            <app-arquivados-protocolos [idServico]="idServico()" [uf]="uf()" [tipoPessoa]="tipoPessoa()" [numeroBusca]="numeroBuscado()" (protocoloSelecionado)="onSelect($event)" />
        } @else {
            @if (carregando()) {
                <div class="estado-vazio">
                    <span class="estado-vazio-icone"><i class="pi pi-spin pi-spinner"></i></span>
                    <p class="estado-vazio-titulo">Carregando protocolos...</p>
                </div>
            } @else {
                <!--
                    O quadro é montado mesmo com a listagem viva vazia, e o estado vazio mora LÁ DENTRO.
                    A listagem que chega por `itens` traz só os protocolos vivos (situação A/T); os
                    CONCLUÍDOS vêm por fora, de uma busca que só o kanban faz. Decidir "não há nada" aqui
                    escondia justamente a coluna Concluído recém-preenchida por um encerramento em lote —
                    o quadro sumia inteiro no momento em que o analista ia conferir o resultado.
                -->
                <app-kanban-protocolos
                    [itens]="itensFiltrados"
                    [idServico]="idServico()"
                    [uf]="uf()"
                    [tipoPessoa]="tipoPessoa()"
                    [exibirFiltroAnuidade]="exibirFiltroAnuidade()"
                    [codigoServico]="codigoServico()"
                    (itemSelected)="onSelect($event)"
                    (avisoPendenciaSolicitado)="avisoPendenciaSolicitado.emit($event)"
                    (encerrarEmLoteSolicitado)="encerrarEmLoteSolicitado.emit($event)"
                ></app-kanban-protocolos>
            }
        }
    </div>
</div>

<p-dialog
    appDialogoPadrao="pi pi-briefcase"
    descricao="Recorte o quadro pelos critérios escolhidos."
    header="Filtrar protocolos"
    [visible]="exibirDialogFiltros()"
    (visibleChange)="exibirDialogFiltros.set($event)"
    [style]="{ width: '24rem' }"
    [breakpoints]="{ '640px': '92vw' }"
>
    <div class="dialog-options">
        @for (filtro of filtrosPagamentoVisiveis; track filtro.value) {
            <button type="button" class="dialog-option" [class.ativo]="filtroPagamentoAplicado === filtro.value" (click)="selecionarFiltroPagamento(filtro.value)">
                <span>{{ filtro.label }}</span>
                @if (filtroPagamentoAplicado === filtro.value) {
                    <i class="pi pi-check"></i>
                }
            </button>
        }
    </div>
</p-dialog>
